export const SP = {
  navSmartPhrases: "nav-smartphrases",
  page: "smartphrases-page",
  title: "smartphrases-title",
  newBtn: "smartphrases-new-btn",
  search: "smartphrases-search",
  statusFilter: "smartphrases-status-filter",
  formatFilter: "smartphrases-format-filter",
  ownerFilter: "smartphrases-owner-filter",
  clearFilters: "smartphrases-clear-filters",
  table: "smartphrases-table",
  loading: "smartphrases-loading",
  emptyState: "smartphrases-empty",
  errorState: "smartphrases-error",
  row: "smartphrases-row",
  editBtn: "smartphrases-edit-btn",
  duplicateBtn: "smartphrases-duplicate-btn",
  moreBtn: "smartphrases-more-btn",
  formPage: "smartphrase-form-page",
  formTitle: "smartphrase-form-title",
  backLink: "smartphrase-form-back",
  cancelBtn: "smartphrase-form-cancel",
  saveBtn: "smartphrase-form-save",
  nameInput: "smartphrase-name",
  descriptionInput: "smartphrase-description",
  formatSelect: "smartphrase-format",
  statusSelect: "smartphrase-status",
  ownerDisplay: "smartphrase-owner",
  contentEditor: "smartphrase-content",
  insertPlaceholder: "smartphrase-insert-placeholder",
  placeholderSearch: "smartphrase-placeholder-search",
  wordCount: "smartphrase-word-count",
  charCount: "smartphrase-char-count",
};
